import { Controller } from "@hotwired/stimulus";
import { Offcanvas } from "bootstrap";

// Connects to data-controller="offcanvas"
export default class extends Controller {
  connect() {
    console.log("Offcanvas controller connected");
  }

  open(event) {
    event.preventDefault();
    console.log("Opening offcanvas");
    
    // Find the offcanvas element
    const offcanvasElement = document.getElementById("myOffcanvas");
    
    if (offcanvasElement) {
      // Create a new Bootstrap Offcanvas instance
      const offcanvasInstance = new Offcanvas(offcanvasElement);
      offcanvasInstance.show();
    } else {
      console.error("Could not find offcanvas element with ID: myOffcanvas");
    }
  }
}
